import styled from "styled-components";

import { Text } from "@similarweb/ui-components/foundations";

export const DropdownOptionText = styled(Text)`
    text-indent: 0;
`;
